<div class="flex flex-column gap-2 form-input ">
    <label  class="justify-content-start d-flex">{{label}}
      <span *ngIf="mandatory" class="text-danger">*</span>
    </label>
    <form [formGroup]="form">
      <div class="d-flex   prime-phone">
        <p-dropdown [appendTo]="'body'" [ngClass]="{
          'border-danger': isInErrorState
        }" formControlName='code' (onChange)="countryCodeSelect($event)" [(ngModel)]="countryCode" [filter]="true" optionValue="country_code" optionLabel="country_code" styleClass="d-flex align-items-center position-relative w-100  input-field" [options]="suggestionList">
          <ng-template let-item pTemplate="selectedItem">
            <div>
              <img class="mr-2" [src]="imageBaseUrl+'' + '' + item.flag_url" alt="flag" width="19" height="15" onerror="this.src='assets/images/default-icon.jpg'">{{item.country_code}}
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div>
              <img class="mr-2" [src]="imageBaseUrl+'' + '' + item.flag_url" alt="flag" width="19" height="15" onerror="this.src='assets/images/default-icon.jpg'">{{item.country_code}} {{item.country}}
            </div>
          </ng-template>
        </p-dropdown>
          <input  [ngClass]="{
            'border-danger-input': isInErrorState
          }" (focusout)="elementTouced()" pKeyFilter="int" [(ngModel)]="mobileNumber" (keyup)="inputValid()"  class="input-field number-field" formControlName="mobileNumber"/>
      </div>
    </form>
</div>